module.exports = __webpack_public_path__ + "media/images/landing_page/peteris_un_sandra_1-6c313529c63f602c0ff27999b11dca17.webp";